/* eslint-disable */
import React, { useState } from "react";
import AsyncSelect from "react-select/async";

//url and methods
import { getData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import { reactSelectStyle } from "Config/Config";

const ShareWithDoctor = ({
  selectedPatientIds = [],
  onPopupCLose = () => {},
}) => {
  const token = localStorage.getItem("token");

  const [doctor, setDoctor] = useState(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const [connectResponses, setConnectResponses] = useState([]);

  // Async load options for doctor
  const loadDoctorOptions = async (inputValue) => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=DOCTOR`;

      const reponse = await getData(requestUrl);
      return reponse.data;
    } catch (error) {
      return [];
    }
  };

  //connect function
  const connectPatientWithDoctorHandler = async () => {
    if (selectedPatientIds.length === 0) {
      return;
    }

    setIsConnecting(true);

    for (let patientId of selectedPatientIds) {
      try {
        const apiData = {
          patientid: patientId,
          doctor: doctor ? doctor.value : null,
        };

        const requestUrl =
          url.API_BASE_URL +
          url.API_CONNECT_PATIENT_WITH_DOCTOR +
          `?token=${token}`;

        const response = await postData(requestUrl, apiData);

        setConnectResponses((prev) => [...prev, response.data]);
      } catch (error) {
        console.log(error.message);
      }
    }

    setIsConnecting(false);
  };

  //reset handler
  const resetHandler = () => {
    setDoctor(null);
    setConnectResponses([]);
    onPopupCLose();
  };

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="shareWithDoctor"
      aria-labelledby="shareWithDoctor"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              share
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              Share With Doctor
            </h3>
            <p className="text-white fs-sm mb-0">
              Connect patients with a doctor
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fw-semibold mb-2">Select Doctor</label>
              <AsyncSelect
                isClearable
                name="doctor"
                loadOptions={loadDoctorOptions}
                defaultOptions={false}
                cacheOptions={false}
                placeholder="Select Doctor"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={doctor}
                onChange={setDoctor}
              />

              {doctor ? (
                <div className="patient-details mt-3">
                  {/* Patient details */}
                  <div className="d-flex gap-3">
                    <div
                      className="avatar rounded-circle overflow-hidden"
                      style={{
                        width: "60px",
                        height: "60px",
                      }}
                    >
                      <img
                        className="w-100 h-100 object-fit-cover"
                        src={
                          doctor?.image !== ""
                            ? url.SERVER_URL + doctor?.image
                            : assetImages.defaultUser
                        }
                        alt="patient"
                      />
                    </div>
                    <div>
                      <p className="mb-0">{doctor?.label}</p>
                      <p className="font-sm text-gray mb-1">
                        Email: {doctor?.email}
                      </p>
                    </div>
                  </div>
                  {/* Calendar details for patient */}
                  <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                    <p className="fw-semibold mb-2">
                      Information for {doctor?.label}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      Phone: {doctor?.phone}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      City: {doctor?.city}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      State: {doctor?.state}
                    </p>
                    <p className="font-sm text-gray mb-1">
                      Country: {doctor?.country}
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={connectPatientWithDoctorHandler}
                disabled={isConnecting}
                style={{ cursor: isConnecting ? "not-allowed" : "pointer" }}
              >
                {isConnecting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Connecting...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined">send</span>
                    <span>Share</span>
                  </>
                )}
              </button>
            </div>

            {/* Connect Responses UI */}
            {connectResponses.length > 0 && (
              <div className="mt-4">
                <h5 className="fw-bold mb-3">Connection Status</h5>
                <ul className="list-group d-flex flex-column gap-3">
                  {connectResponses.map((res, idx) => (
                    <li
                      key={idx}
                      className={`list-group-item d-flex align-items-center gap-3 px-3 py-3 rounded-3`}
                      style={{
                        border: `1px solid ${
                          res.contact ? "#28a745" : "#dc3545"
                        }`,
                        background: "#f8f9fa",
                      }}
                    >
                      {/* Patient Avatar */}
                      <div
                        className="avatar rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                        style={{
                          width: "48px",
                          height: "48px",
                          flexShrink: 0,
                          background: "#fff",
                          border: "1px solid #dee2e6",
                        }}
                      >
                        <img
                          className="w-100 h-100 object-fit-cover"
                          src={
                            res.patient?.image !== ""
                              ? url.SERVER_URL + res.patient.image
                              : assetImages.defaultUser
                          }
                          alt={res.patient?.name || "patient"}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <span className="fw-semibold fs-5">
                          {res.patient?.name || "Unknown Patient"}
                        </span>
                        {res.contact ? (
                          <span className="badge bg-success ms-2">
                            Contact Created
                          </span>
                        ) : (
                          <span className="badge bg-danger ms-2">
                            Contact Not Created
                          </span>
                        )}
                        <div className="text-muted font-sm mt-1">
                          {res.contact
                            ? "Contact created successfully."
                            : `Contact creation failed for ${
                                res.patient?.name || "patient"
                              }.`}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ShareWithDoctor;
